<template>
	<div id="app">
		<rp-nav
			:page-name="pageName"
			:pages="pages"
		></rp-nav>
		<router-view
			class="px-64"
			:key="$route.fullPath"
		/>
	</div>
</template>

<script>
import RpNav from "./components/RpNav";
import ListItems from "./views/ListItems.vue";

export default {
	components: {
		RpNav
	},
	data() {
		return {
			pages: [
				{
					name: "Accueil",
					path: "/"
				},
				{
					name: "Contact",
					path: "/contact"
				}
			]
		};
	},
	computed: {
		pageName() {
			return this.$route.name;
		}
	},
	created() {
		this.addRoutes();
	},
	methods: {
		addRoutes() {
			this.$prismic.client
				.query(this.$prismic.Predicates.at("document.type", "rubriques"))
				.then(response => {
					const res = response.results[0].data.rubriques;
					let test = [];
					res.forEach(el => {
						const documentType = el.categories[0].text
							.toLowerCase()
							.normalize("NFD")
							.replace(/[\u0300-\u036f]/g, "")
							.replace(/\s/g, "_");
						test.push({
							path: `/${el.categories[0].text}`,
							name: el.categories[0].text,
							component: ListItems,
							props: {
								documentType,
								type: el.categories[0].text
							}
						});
					});
					this.$router.addRoutes(test);
					this.pages = [
						{
							name: "Accueil",
							path: "/"
						},
						...test,
						{
							name: "Contact",
							path: "/contact"
						}
					];
				});
		}
	}
};
</script>

<style>
body {
	height: 100%;
	background-color: #e5e7eb;
	background-image: url("./assets/bg.jpg");
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
}
</style>
